// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AddRmaApiParameter } from "@insite/client-framework/Services/OrderService";
import { RmaModel } from "@insite/client-framework/Types/ApiModels";

const orderhistoryPODServiceUrl = "/api/vmi/orderhistory/GetPOD";

const addRMAServiceUrl = "api/vmi/orderhistory/addRma";

export type GetPODApiParameter = {
    erpOrderNumber: string, generatedId: string
};

export async function getPOD(parameter: GetPODApiParameter): Promise<any> {
    const result = await get<any>(orderhistoryPODServiceUrl, {}, { orderNumber: parameter.erpOrderNumber, generationId: parameter.generatedId });
    return result;
}

export async function addRma(parameter: AddRmaApiParameter): Promise<ServiceResult<RmaModel>> {
    try {
        const rmaModel = await post<RmaModel>(
            addRMAServiceUrl,
            parameter.rmaModel,
        );
        return {
            successful: true,
            result: rmaModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
